module.exports = __webpack_public_path__ + "img/leftImgBack.f3197598.png";